export default function (isFetchDone) {
  console.log(isFetchDone);
  return function (fn) {
    console.log(arguments);
    if (!isFetchDone) throw new Promise((resolve, reject) => {});
    return fn;
  };
}
